import type { ITwoFactorMethod } from '@/types/AuthTypes'

import type { IRoleAll } from './RoleTypes'

export const LocalStorageKeys = {
  AUTH: 'auth',
  AUTH_IN_PROGRESS: 'auth_in_progress',
  PATHWAYS: 'pathways',
  DATATABLE_FILTERS: 'datatable_filters',
} as const

export interface IRole {
  uuid: string
  name: string
  isBase: string
}

export interface IUser {
  uuid: string
  firstName: string
  lastName: string
  email: string
  isActive: boolean
  twoFactorMethods: ITwoFactorMethod[]
  roles: IRole[]
  roleId: number
  fullName?: string
  createdAt: string
  updatedAt: string
  deletedAt: Nullable<string>
  lastLogoutDate: Nullable<string>
}

export interface IUserList {
  uuid: string
  firstName: string
  lastName: string
  email: string
  isActive: boolean
  emailVerifiedAt: Nullable<string>
  passwordSetAt: Nullable<string>
  createdAt: string
  updatedAt: string
  deletedAt: string
  lastLogoutDate: string
  twoFactorMethods: ITwoFactorMethod[]
  roles: IRoleAll[]
}
